/* eslint-disable prettier/prettier */
import styled, { css } from 'styled-components';

interface StatusProps {
  status?: 'C' | 'F' | 'E' | 'B';
}

export const BaseContainer = styled.div`
  margin-top: 0px;
  padding: 0px;
`;

const StatusVariations = {
  C: css`
    background: var(--green);
  `,
  E: css`
    background: var(--orange);
  `,
  F: css`
    background: var(--purple);
  `,
  B: css`
    background: var(--green);
  `,
  P: css`
    background: var(--purple);
  `,
};

export const ModalContent = styled.div`
  height: 250px;
  width: 600px;
  padding: 0px 15px 30px 15px;
  text-align: center;
  p {
    padding-bottom: 10px;
  }
`;

export const ModalWrapper = styled.div`
  width: 100%;
  text-align: center;

  .button-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 50px;
  }

  p {
    justify-content: center;
    text-align: left;
    margin-top: 20px;
    margin-bottom: 50px;
  }
`;

export const ModalContentCancelar = styled.div`
  height: 150px;
  width: 600px;
  padding: 0px 10px 20px 10px;
  text-align: center;
  p {
    padding-bottom: 10px;
  }
`;

export const LinkModal = styled.a`
  text-decoration: underline;
  color: var(--purple) !important;
  width: 50px;
  height: auto;
  cursor: pointer;
  :hover {
    color: var(--orange)
  }
  padding-right: 5px;
`;

export const Container = styled.div`
  .titleWrapper {
    height: 117px;
  }

  .TitleContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media only screen and (max-width: 768px) {
      margin-top: -25px;
      justify-content: center;
    }
  }

  .title {
    @media only screen and (max-width: 767px) {
      text-align: center;
    }
  }

  .infoitem {
    @media only screen and (max-width: 767px) {
      margin-top: 20px;
      text-align: center;
    }
  }
`;

export const Title = styled.h1`
  font-family: Roboto Slab;
  font-style: normal;
  font-weight: bold;
  font-size: 45px;
  line-height: 59px;

  color: var(--orange);

  align-items: center;
  justify-content: space-between;

  @media only screen and (max-width: 768px) {
    margin-top: 30px;
  }

  @media only screen and (max-width: 767px) {
    margin-top: 0px;
  }
`;

export const ButtonsContainerInitial = styled.h1`
  .buttonsInitial {
    display: flex;
    margin-top: 5px;
    margin-top: 16px;
    button {
      font-size: 0.9rem;
      border-radius: 17px 17px;
      display: flex;
      align-items: center;
      margin-right: 10px;
      transition: background 0.3s ease;
    }
    .pedido {
      padding: 10px 40px;
      &:hover {
        background: #b14729;
      }
    }
    @media only screen and (max-width: 768px) {
      justify-content: center;
    }
  }
  @media only screen and (max-width: 768px) {
    margin-top: 10px;
    margin-left: 0;
  }
  @media only screen and (max-width: 767px) {
    margin-top: 10px;
    margin-left: 0;
  }
`;

export const FiltersContainer = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 28px;

  @media only screen and (max-width: 1225px) {
    flex-direction: column;
  }

  @media only screen and (max-width: 924px) {
    margin-top: 100px;
  }

  @media only screen and (max-width: 768px) {
    margin-top: 50px;
  }

  @media only screen and (max-width: 767px) {
    margin-top: 100px;
  }

  .filter {
    margin-right: 5px;
    @media only screen and (max-width: 1225px) {
      margin-bottom: 10px;
    }
    button {
      font-size: 0.9rem;
      display: flex;
      align-items: center;
      transition: background 0.3s ease;
      color: black;

      &:hover {
        background: #9ea1a2;
      }
    }
  }

  .search {
    width: 100%;
    @media only screen and (max-width: 1225px) {
      margin-bottom: 10px;
    }

    form {
      position: relative;
    }
    div {
      height: 40px;
      margin-top: -4px;
      input {
        font-size: 18px;
      }
    }
    .searchButton {
      position: absolute;
      right: 0px;
      top: 0;
      display: flex;
      align-items: center;
      transition: background 0.3s ease;

      &:hover: {
        background: red;
      }
    }
  }
  .buttonsContainer {
    display: flex;
    button {
      width: 120px;
      font-size: 0.9rem;
      border-radius: 17px 17px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 10px;
      transition: background 0.3s ease;
    }
    .clearFilters {
      width: 145px;
      border-radius: 5px;
      margin-left: 5px;
      font-size: 0.9rem;
      display: flex;
      align-items: center;
      transition: background 0.3s ease;
      color: black;
      background-color: var(--aside-background);

      &:hover {
        background: #9ea1a2;
      }
      @media only screen and (max-width: 1225px) {
        margin-left: 0px;
      }
    }
    .csv {
      color: var(--white);
      border: 2px solid var(--purple);
      &:hover {
        background: var(--white);
        color: var(--purple);
      }
    }
    .pdf {
      color: var(--white);
      border: 2px solid var(--purple);
      &:hover {
        background: var(--white);
        color: var(--purple);
      }
    }
  }
`;

export const StatusRow = styled.div<StatusProps>`
  color: var(--white);
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;

  ${props => StatusVariations[props.status || 'C']}
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  button {
    background: transparent;
    color: #403e3e;
    height: 40px;
    width: 40px;
    border-radius: 5px;
    margin-right: 0px;
    font-family: 'Source Sans Pro' sans-serif;
    font-size: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .cancel {
    background: transparent;
    color: var(--orange);
  }
`;

export const DetailLink = styled.div`
  cursor: pointer;
  color: var(--purple);
  text-decoration: underline;
  text-underline-position: under;
  }
`;

export const FormWrapper = styled.div`
  width: 100%;
  Form {
    margin-top: 20px;
  }

  input {
    height: 40px;
  }
  .btn-wrapper {
    margin-top: 30px;
    display: flex;
    width: 100%;
    button {
      width: inherit;
    }

    .btn-cancelar {
      color: #757575;
      background-color: #fff;
      border: 1px solid #e8e8e8;
      margin-right: 20px;
    }
  }
`;
